/**
 * Created by mgoria on 11/03/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingLambdaLocalPathException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let MissingLambdaLocalPathException = exports.MissingLambdaLocalPathException = function (_Exception) {
  _inherits(MissingLambdaLocalPathException, _Exception);

  /**
   * @param {String} lambdaArn
   */
  function MissingLambdaLocalPathException(lambdaArn) {
    _classCallCheck(this, MissingLambdaLocalPathException);

    return _possibleConstructorReturn(this, (MissingLambdaLocalPathException.__proto__ || Object.getPrototypeOf(MissingLambdaLocalPathException)).call(this, `Missing local path for Lambda ${lambdaArn}`));
  }

  return MissingLambdaLocalPathException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/MissingLambdaLocalPathException.js
// module id = 421
// module chunks = 0